// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loyalty-image[data-v-31162254]{aspect-ratio:1.4136363636;height:220px;margin:0 auto;position:relative}.loyalty-image img[data-v-31162254]{border-radius:.4rem;height:220px}.loyalty-image button[data-v-31162254]{bottom:1rem;left:1rem;position:absolute;width:calc(100% - 2rem)}.loyalty-image button[data-v-31162254]:before{content:none!important}@media screen and (min-width:1024px){.loyalty-image[data-v-31162254]{height:220px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
